import classNames from 'classnames';
import React from 'react';

import AnimateReveal from '../AnimateReveal/AnimateReveal';
import Content from '../UI/Content/Content';
import Section, { themes } from '../UI/Section/Section';
import * as styles from './ContentBlock.module.scss';

const container = {
  hidden: { opacity: 0, y: 70 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'circOut',
      delay: 1,
      when: 'beforeChildren',
      staggerChildren: 0.15,
    },
  },
};

const ContentBlock = ({ heading, body, aside, children, ...other }) => {
  const className = classNames(styles.container, {
    [ styles.hasAside ]: !!aside,
  });

  return (
    <Section {...other} theme={themes.BASIC}>
      <div className={className}>
        <AnimateReveal className={styles.body} at="20px" variants={container}>
          <div className={styles.bodyInner}>
            {heading && <h2>{heading}</h2>}
            {body ? <Content items={body} allowBreakout={!aside} /> : children }
          </div>
        </AnimateReveal>

        {aside && (
          <aside className={styles.aside}>
            <div className={styles.asideInner}>
              <Content items={aside} />
            </div>
          </aside>
        )}
      </div>
    </Section>
  );
};

export default ContentBlock;
